import { useTranslation } from 'react-i18next';
import {
  ADMIN_DASHBOARD,
  SIGN_IN_ROUTE,
  TEMPLATES_ROUTE_V2,
} from '../constants/routePathConstants';
import { useNavigate } from 'react-router-dom';
import { BigButton } from '../common';
import { usePageTitle } from '../hooks/usePageTitle';
import { useUserContext } from '../contexts/UserContext';
import { REQUESTS_ROUTE } from '../config/constant/routePathConstant';

export default function NotFound(props) {
  const { t } = useTranslation('common');
  const { currentUser, isGuestUser, isGuestLogin } = useUserContext();
  const navigate = useNavigate();
  const Component = props?.as || 'h1';
  const pgTitle = isGuestUser() || isGuestLogin ? t('access_denied') : props?.pageTitle || t('page_not_found');
  const message = isGuestUser() || isGuestLogin ? t('access_denied') : props?.message || t('page_not_found');
  const isV2 = props?.isV2 || false;
  const data = props?.data;
  const buttonTitle = props?.buttonTitle || t('go_back');

  if (!props?.hidePageTitle) usePageTitle(pgTitle);

  const goBack = () => {
    if (currentUser) {
      const URL = isGuestUser()
        ? REQUESTS_ROUTE
        : isGuestLogin
        ? TEMPLATES_ROUTE_V2
        : ADMIN_DASHBOARD;
      navigate(URL);
      return;
    }
    navigate(SIGN_IN_ROUTE);
  };

  const handleClick = () => {
    if (props?.onClick) {
      props?.onClick?.();
      return;
    }
    goBack?.();
  };

  return (
    <div
      className={`d-flex justify-content-center align-items-center flex-column h-100 ${
        props?.className || ''
      }`}>
      {isV2 ? (
        <div
          className="accessRestrictedContainer text-center p-4 border shadow bg-white"
          style={{ borderRadius: '5px' }}>
          <h4 className="text-danger mb-2">{t('access_restricted')}</h4>
          <p>
            {t('product_page_contains_details', { type: data?.product ? t('product') : t('texture') })}{' '}
            <strong>{data?.product_details?.name || data?.texture_details?.name}</strong>
            {t('no_permission_to_view')}
          </p>
          <p className="text-start mb-1">{t('this_may_be_due_to')}</p>
          <ul className="text-start mb-0">
            <li>{t('public_access_disabled')}</li>
            <li>{t('page_shared_different_email')}</li>
          </ul>
        </div>
      ) : (
        <>
          <Component className="m-3">{message}</Component>
          {props?.hideButton ? null : (
            <BigButton
              className="bigButton lf-btn-1"
              onClick={handleClick}
              buttonTitle={buttonTitle}
            />
          )}
        </>
      )}
    </div>
  );
}
